module.exports = __webpack_public_path__ + "static/rust-monster-mtg_afr-fe7c3b3f42cadf235a15b53aaacf7de4.jpg";